import { ButtonIcon } from 'components/Button';
import { Portal } from 'components/Portal';
import { Header } from 'components/Header';
import PropTypes from 'prop-types';
import Checkbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';
import React, { useCallback, useState } from 'react';
import { TableLabel, TableProp, TableValueDynamic, TableValueDynamicAutoComplete } from './TableItems';
import '../style.scss';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

const regularPassportMask = 'AA 999999 від 99.99.9999';
const idPassportMask = '999999999 від 99.99.9999';

const regularPassportPlaceholder = 'AA 123456 від 12.06.1999';
const idPassportPlaceholder = '123456789 від 12.06.1999';

const ModalCreateIndividual = ({
  onSubmit,
  onClose,
  pending,
  clientNumber,
  isFromMainPage,
  defaultValues,
  historyParams,
}) => {
  const [values, setValues] = useState({
    EDRPOU: '',
    FIO: '',
    PhMain: clientNumber,
    PhAdd: '',
    INN: '',
    document: '',
    AddrOfficial: '',
    AddrFact: '',
    AddrPost: '',
    Email: '',
    ...defaultValues,
  });
  const [errors, setErrors] = useState({});
  const [isIdCard, setIsIdCard] = useState(false);
  const onIdCardChange = (event) => {
    setIsIdCard(event.target.checked);
    handleValue('document', '');
  };
  const history = useHistory();

  const handleCopy = () => {
    handleValue('AddrFact', values.AddrOfficial);
  };

  const isClientValid = useCallback(
    () => values.PhMain.length > 0 && !values.PhMain.includes('X') && values.FIO.length > 0,
    [values]
  );

  const handleSave = async () => {
    if (!isClientValid()) {
      return;
    }
    const errors = {};
    if (values.FIO.length === 0) {
      errors.FIO = true;
    }

    if (values.PhMain.length === 0) {
      errors.PhMain = true;
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    const data = await onSubmit(values);
    if (!!clientNumber || isFromMainPage) {
      history.push(`client/${data.id}`);
    }
    onClose();
  };

  const handleValue = (key, value) => {
    if (errors[key]) {
      setErrors({ ...errors, [key]: false });
    }
    setValues({ ...values, [key]: value });
  };

  return (
    <Portal id="modal-create-client" className="modal-create-client individ" onClose={onClose}>
      <Header title="Новый контрагент" onClose={onClose}></Header>

      <div className="client-create-grid individ">
        <TableProp title="ФИО" icon="userverify" required={true} />
        <TableValueDynamic
          error={errors.FIO}
          value={values.FIO}
          onChange={(value) => handleValue('FIO', value)}
          placeholder="ФИО"
          autoFocus={!!clientNumber}
        />

        <TableProp title="Телефон осн." icon="phone" required={true} />
        <TableValueDynamicAutoComplete
          err={errors.PhMain}
          value={values.PhMain}
          onChange={(value) => handleValue('PhMain', value)}
          mask="+380 99 999 99 99"
          placeholder="+380 XX XXX XX XX"
          search="search"
          historyParams={historyParams}
        />

        <TableProp title="Телефон доп." icon="phone" />
        <TableValueDynamicAutoComplete
          err={errors.PhAdd}
          value={values.PhAdd}
          onChange={(value) => handleValue('PhAdd', value)}
          mask="+380 99 999 99 99"
          placeholder="+380 XX XXX XX XX"
          search="search"
          historyParams={historyParams}
        />

        <TableProp title="ИНН" icon="hashtag" />
        <TableValueDynamicAutoComplete
          error={errors.INN}
          value={values.INN}
          onChange={(value) => handleValue('INN', value)}
          mask="9999999999"
          placeholder="XXXXXXXXXX"
          search="INN"
          historyParams={historyParams}
        />

        <TableProp title="Документ" icon="passport" />

        <div className="passport-field">
          <TableValueDynamic
            err={errors.document}
            value={values.document}
            onChange={(value) => handleValue('document', value)}
            placeholder={isIdCard ? idPassportPlaceholder : regularPassportPlaceholder}
            mask={isIdCard ? idPassportMask : regularPassportMask}
          />
          <label className="id-card-checkbox">
            <Checkbox checked={isIdCard} onChange={onIdCardChange} />
            ID-карта
          </label>
        </div>

        <TableProp title="Адр. прописки" icon="location" />
        <TableValueDynamic
          err={errors.AddrOfficial}
          value={values.AddrOfficial}
          onChange={(value) => handleValue('AddrOfficial', value)}
          placeholder="Адрес прописки"
        />

        <TableLabel onClick={handleCopy} text="Проживает по адресу прописки" icon="copy" />

        <TableProp title="Адр. прожив." icon="location" />
        <TableValueDynamic
          err={errors.AddrFact}
          value={values.AddrFact}
          onChange={(value) => handleValue('AddrFact', value)}
          placeholder="Адрес проживания"
        />
      </div>

      <div className="buttons-block" style={{ margin: 0, marginBottom: 15 }}>
        <ButtonIcon
          className={cn('btn-main', 'btn-save', !isClientValid() && 'btn-disabled')}
          icon="save"
          pending={pending}
          onClick={handleSave}
          text="Сохранить"
        />
      </div>
    </Portal>
  );
};

ModalCreateIndividual.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  pending: PropTypes.bool,
  isFromMainPage: PropTypes.bool,
  clientNumber: PropTypes.string,
  defaultValues: PropTypes.object,
  historyParams: PropTypes.object,
};

ModalCreateIndividual.defaultProps = {
  pending: false,
  clientNumber: '',
  isFromMainPage: false,
  defaultValues: {},
  historyParams: {},
};

export { ModalCreateIndividual };
